import Icon from "../../../assets/images/logo-header.svg";
import { Dropdown } from "antd";
import downWhite from "../../../assets/images/down-white.svg";
import { logout } from "utilities/HttpUtility";
import { useTranslation } from "react-i18next";
import CustomDropDown from "./CustomDropDown";


const Header = () => {
  const { t } = useTranslation();
  
  const profileitems = [

    {
      key: "2",
      label:
      <div>

      <div rel="noopener noreferrer" className="profile-header-item text-gray-e fs16 w-100 py-2 ps-3" onClick={logout}>{t('logout')}</div>
      </div>
    },
  ];

  const user_name = sessionStorage.getItem('user_name');
  const user_email = sessionStorage.getItem('user_email');

  const recipientNameHandle = (name) => {
    if (!name || name === "") {
      return "";
    }
    let nameParts = name.split(" ");

    if (nameParts.length === 1) {
      let singleNameInitials = nameParts[0].substring(0, 2).toUpperCase();
      return singleNameInitials;
    }

    let firstNameInitial = nameParts[0].charAt(0);
    let lastName = nameParts[1];

    let lastNameInitials =
      lastName.length >= 2 ? lastName.substring(0, 2) : lastName.charAt(0);

    return `${firstNameInitial}${lastNameInitials}`;
  };
  return (
    <nav className="navbar navbar-light header-nav">
      <div className="container-fluid px-0">
        <img src={Icon} alt="logo" className="navbar-brand" />
        <form className="d-flex">
          <div className="page-header mt7">
            <CustomDropDown />
          </div>

          <ul className="navbar-nav ms-4">

            <li className="nav-item dropdown">
              <Dropdown
                menu={{
                  items: profileitems,
                }}
                trigger={["click"]}
              >
                <div className="logout-dropdown" onClick={(e) => e.preventDefault()}>
                   <div className="d-flex align-items-center">
                     <div className="me-2 ms-1">
                       <span className="user-initial-circle">
                         {recipientNameHandle(user_name)}
                       </span>
                     </div>
                     <div className="">
                       <div className="text-white poppins-medium fs14 text-capitalize">{user_name ? user_name : 'Calingo operator'}</div>
                       <div className="text-white fs12">{user_email || ''}</div>
                     </div>
                     <div className="ms-3">
                       <img src={downWhite} alt="arrow" className="cursor-pointer"/>
                     </div>
                   </div>




                </div>
              </Dropdown>
            </li>
          </ul>
        </form>
      </div>
    </nav>
  );
};
export default Header;
